import { useCallback } from 'react'
import { DateTime } from 'luxon'

import { EtaDistanceResult, EtaLocation, EtaLocationType } from '@/feature/eta'

import { formatTimeStamp } from '../utils/Eta.utils'

interface UseEtaCopyToClipboardProps {
  etaLocationFrom: EtaLocation
  etaLocationTo: EtaLocation
  etaResult: EtaDistanceResult | undefined
}

export const useEtaCopyToClipboard = ({
  etaLocationFrom,
  etaLocationTo,
  etaResult,
}: UseEtaCopyToClipboardProps): (() => string) => {
  return useCallback(() => {
    const copyData = {
      assetDescription:
        etaLocationTo?.type === EtaLocationType.ASSET
          ? etaLocationTo?.title
          : etaLocationFrom?.type === EtaLocationType.ASSET
            ? etaLocationFrom?.title
            : '',
      assetLicensePlate:
        etaLocationTo?.type === EtaLocationType.ASSET
          ? etaLocationTo?.plateNumber
          : etaLocationFrom?.type === EtaLocationType.ASSET
            ? etaLocationFrom?.plateNumber
            : '',
      locationTo:
        etaLocationTo?.type === EtaLocationType.GEOFENCE
          ? etaLocationTo?.title
          : etaLocationTo?.address,
      locationFrom:
        etaLocationFrom?.type === EtaLocationType.GEOFENCE
          ? etaLocationFrom?.title
          : etaLocationFrom?.address,
      eta: formatTimeStamp(etaResult?.duration?.value),
      departureTime: DateTime.fromJSDate(etaResult?.departureTime ?? new Date())
        .setLocale('en-gb')
        .toFormat("dd'/'MM'/'yyyy' 'HH':'mm"),
      distanceTo: etaResult?.distance,
      durationTo: etaResult?.duration?.text,
    }

    return `New ETA ${copyData.departureTime}
${[
  copyData.assetDescription ? `Asset Description: ${copyData.assetDescription}` : '',
  copyData.assetLicensePlate ? `Asset License Plate: ${copyData.assetLicensePlate}` : '',
  `Location From: ${copyData.locationFrom}`,
]
  .filter((s) => s)
  .join(
    '\n',
  )}\nLocation To: ${copyData.locationTo}\nETA: ${copyData.eta}\nDistance To: ${copyData.distanceTo}\nDuration To: ${copyData.durationTo}`
  }, [etaLocationFrom, etaLocationTo, etaResult])
}
